import { render, staticRenderFns } from "./_betLimitLog.vue?vue&type=template&id=2cc98b9c&lang=pug&"
import script from "./_betLimitLog.vue?vue&type=script&lang=js&"
export * from "./_betLimitLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports